import React from 'react';
import { Link } from 'react-router-dom';

export const NotFound = () : JSX.Element => (
  <div style={{ margin: '40px auto 0', textAlign: 'center' }}>
    <i className="large wf-lazy material-icons" style={{ fontSize: '85px', color: '#ea2c2f' }}>error</i>

    <br />

    <h3 style={{ fontWeight: 'normal', paddingTop: '16px' }}>Page not found</h3>

    <Link to="/appmarket" className="btn" style={{ marginTop: '40px' }}>
      Not Found.
    </Link>
  </div>
);
